/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import UserInfo from './UserInfo';
import CommentInput from './CommentInput';
import { asyncCreateComment } from '../states/comments/action';
import CommentItem from './CommentItem';
import ThreadVotes from './ThreadVotes';

function DetailThread({ detailThread, authUser }) {
  const {
    title, body, category, createdAt, owner, upVotesBy, downVotesBy, comments,
  } = detailThread;

  const { threadId: id } = useParams();
  const dispatch = useDispatch();

  const onComment = ({ content, threadId }) => {
    dispatch(asyncCreateComment({ content, threadId }));
  };

  return (
    <section className="thread-item">
      <UserInfo createdAt={createdAt} avatar={owner.avatar} name={owner.name} category={category} />
      <article className="thread-item__article">
        <h2 className="thread-item__title">{title}</h2>
        <p className="thread-item__text" dangerouslySetInnerHTML={{ __html: body }} />
      </article>
      <ThreadVotes
        id={id}
        upVotesBy={upVotesBy}
        downVotesBy={downVotesBy}
        totalComments={comments.length}
        authUser={authUser}
      />
      <CommentInput comments={comments} onComment={onComment} />
      <article className="comments-header">
        <h3>
          {comments.length > 1 ? `Comments(${comments.length})` : `Comment(${comments.length})` }
        </h3>
        {comments.map((comment) => (
          <CommentItem key={comment.id} {...comment} authUser={authUser} />
        ))}
      </article>
    </section>
  );
}

const authUser = {
  id: PropTypes.string,
  name: PropTypes.string,
  email: PropTypes.string,
  avatar: PropTypes.string,
};

const detailThreadShape = {
  id: PropTypes.string,
  title: PropTypes.string,
  totalComments: PropTypes.number,
  body: PropTypes.string,
  category: PropTypes.string,
  createdAt: PropTypes.string,
  authUser: PropTypes.shape(authUser).isRequired,
};

DetailThread.propTypes = {
  ...detailThreadShape,
};

export default DetailThread;
